import { KBS_CHIP as kbsChip } from './kbsChip';
import { MANUAL_ADD_APP as manualAddApp } from './manualAddApp';
import { SELECTED_APP as selectedApp } from './selectedApp';

export const APPLICATIONS = { kbsChip, manualAddApp, selectedApp };
